/** Thin a year list so x-axis labels don't collide. */
export function thinTicks<T>(items: T[], innerWidth: number, minPx = 56): T[] {
  const maxTicks = Math.max(4, Math.floor(innerWidth / minPx));
  if (items.length <= maxTicks) return items;
  const step = Math.ceil(items.length / maxTicks);
  return items.filter((_, index) => index % step === 0 || index === items.length - 1);
}
